<template>
    <div class="spin-the-wheel">
        <div class="spin-the-wheel__container">
            <div class="spin-the-wheel__container-inner-1">
                <div class="spin-the-wheel__container-inner-2">
                    <WheelKnob class="spin-the-wheel__knob" />
                    <WheelSvg :segments="segments" :is-spinning="isSpinning"
                        :end-rotation="endRotation" :final-rotation="finalRotation"
                        :selected-segment-index="selectedSegmentIndex" />
                </div>
            </div>
            <WheelArrow class="spin-the-wheel__arrow" />
        </div>

        <div class="spin-the-wheel__overlay" v-if="$slots.overlay">
            <slot name="overlay"></slot>
        </div>
    </div>
</template>



<script setup>

import WheelSvg from './WheelSvg.vue';
import WheelKnob from './WheelKnob.vue';
import WheelArrow from './WheelArrow.vue';
import { ref } from 'vue';

const props = defineProps({
    segments: {
        type: Array,
        required: true
    }
});

const emit = defineEmits(['spinComplete', 'spinStart', 'spinError']);

// Reactive state variables
const isSpinning = ref(false);
const endRotation = ref(0);
const finalRotation = ref(0);
const selectedSegmentIndex = ref(-1);

// Spin function
const spin = async (resultValue) => {
    if (isSpinning.value) return;

    isSpinning.value = true;
    selectedSegmentIndex.value = -1;
    emit('spinStart');

    try {
        // Determine the index of the resulting segment
        const resultIndex = props.segments.findIndex(segment => segment.label === resultValue);

        if (resultIndex === -1) {
            throw new Error('Invalid spin result.');
        }

        const spinDuration = 10000; // 10 seconds
        const spinRotations = 10; // Number of full rotations

        // Calculate the angle to land on the result segment
        const segmentAngle = 360 / props.segments.length;
        const resultAngle = 360 - (resultIndex * segmentAngle) - (segmentAngle / 2);
        endRotation.value = (360 * spinRotations) + resultAngle;

        // Wait for the spin animation to complete
        setTimeout(() => {
            isSpinning.value = false;
            finalRotation.value = endRotation.value % 360;
            selectedSegmentIndex.value = resultIndex;
            emit('spinComplete', resultValue);
        }, spinDuration);
    } catch (error) {
        console.error('Spin failed:', error);
        isSpinning.value = false;
        selectedSegmentIndex.value = -1;
        emit('spinError', error);
    }
};

defineExpose({ spin, isSpinning });

</script>